import React, { useState } from "react";
import { DateRangePicker, RangeKeyDict, Range } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import "../dateFilter.css";
import { enUS } from "date-fns/locale";
import { format } from "date-fns";
import { DateIcon } from "../Icons";

interface DateRangeProps {
  onRangeSelect: (range: Range) => void;
  isOpen: boolean;
  toggleComponent: () => void;
  range: Range[];
  setRange: (range: Range) => void;
  isHeader: boolean;
}

const MyDateRangePicker: React.FC<DateRangeProps> = ({
  onRangeSelect,
  isOpen,
  toggleComponent,
  range,
  setRange,
  isHeader = false,
}) => {
  const [step, setStep] = useState("start");

  const handleSelect = (ranges: RangeKeyDict) => {
    const selection: Range = ranges.selection;
    console.log(selection, selection?.startDate, selection.endDate);
    setRange([
      {
        startDate: selection.startDate,
        endDate: selection.endDate,
        key: "selection",
        color: "#3b82f6",
      },
    ]);
    if(step === "start"){
      setStep("end")
    }else{
      setStep("start")
      toggleComponent()
    }
  };

  return (
    <div className="flex flex-col gap-1 min-w-fit relative">
      {!isHeader ? (
        <div
          className="border border-dissabled-btn rounded-lg px-2 py-[0.75rem] text-[14px] flex justify-between items-center cursor-pointer"
          onClick={toggleComponent}
        >
          <span className="ps-2 text-gray-500">
            {range[0]?.startDate && range[0]?.endDate
              ? `${format(new Date(range[0].startDate), "dd/MM/yy")} - ${format(
                  new Date(range[0].endDate),
                  "dd/MM/yy",
                )}`
              : "Select Date"}{" "}
          </span>
          <span>
            <svg
              width="14"
              height="16"
              viewBox="0 0 14 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.33979 15.2627C0.964653 15.2627 0.647569 15.1308 0.388542 14.8669C0.129514 14.603 0 14.2883 0 13.9229V3.43583C0 3.07042 0.129514 2.75576 0.388542 2.49187C0.647569 2.22799 0.964653 2.09604 1.33979 2.09604H3.16021V0.5575C3.16021 0.398472 3.21299 0.265763 3.31854 0.159374C3.4241 0.0531242 3.55576 0 3.71354 0C3.87146 0 4.00458 0.0531242 4.11292 0.159374C4.22139 0.265763 4.27563 0.398472 4.27563 0.5575V2.09604H8.92313V0.541667C8.92313 0.387917 8.97451 0.259166 9.07729 0.155416C9.18021 0.0518048 9.30792 0 9.46042 0C9.61292 0 9.74201 0.0518048 9.84771 0.155416C9.95354 0.259166 10.0065 0.387917 10.0065 0.541667V2.09604H11.8269C12.202 2.09604 12.5191 2.22799 12.7781 2.49187C13.0372 2.75576 13.1667 3.07042 13.1667 3.43583V13.9229C13.1667 14.2883 13.0372 14.603 12.7781 14.8669C12.5191 15.1308 12.202 15.2627 11.8269 15.2627H1.33979ZM1.33979 14.1794H11.8269C11.891 14.1794 11.9498 14.1526 12.0031 14.0992C12.0566 14.0458 12.0833 13.9871 12.0833 13.9229V6.93583H1.08333V13.9229C1.08333 13.9871 1.11007 14.0458 1.16354 14.0992C1.21688 14.1526 1.27562 14.1794 1.33979 14.1794ZM1.08333 5.8525H12.0833V3.43583C12.0833 3.37167 12.0566 3.31292 12.0031 3.25958C11.9498 3.20611 11.891 3.17937 11.8269 3.17937H1.33979C1.27562 3.17937 1.21688 3.20611 1.16354 3.25958C1.11007 3.31292 1.08333 3.37167 1.08333 3.43583V5.8525Z"
                fill="#808080"
              />
            </svg>
          </span>
        </div>
      ) : (
        <button
          onClick={toggleComponent}
          className="p-2 bg-transparent w-fit min-w-fit border border-[#D9D9D9] rounded-md flex items-center gap-2"
        >
          <DateIcon />
          <span className="text-[#333333] text-[0.7rem] min-w-fit font-medium">
            Select Date
          </span>
        </button>
      )}

      {isOpen && (
        <>
          {isHeader ? (
            <div className="absolute right-[-85%] md:right-0 top-full mt-2 z-50">
              <div className="bg-white rounded-lg shadow-[0_8px_24px_rgba(0,0,0,0.12)] overflow-auto">
                <DateRangePicker
                  moveRangeOnFirstSelection={false}
                  showDateDisplay={false}
                  editableDateInputs={false}
                  retainEndDateOnFirstSelection={false}
                  showMonthAndYearPickers={true}
                  onChange={handleSelect}
                  ranges={range}
                  inputRanges={[]}
                  locale={enUS}
                />
              </div>
            </div>
          ) : (
            // <div className="relative mt-2 w-full z-10 date_picker_range_container overflow-auto rounded-lg border border-dissabled-btn bg-white shadow-sm">
            <div className="custom-scrollbar right-0 w-full -translate-x-1/2 top-full mt-2 z-10 date_picker_range_container overflow-auto">
              <DateRangePicker
                moveRangeOnFirstSelection={false}
                showDateDisplay={false}
                editableDateInputs={false}
                retainEndDateOnFirstSelection={false}
                showMonthAndYearPickers={true}
                onChange={handleSelect}
                ranges={range}
                inputRanges={[]}
                locale={enUS}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default MyDateRangePicker;
